<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="ad_card_1"></a><p class="ach">Also by Janet Fitch</p><p class="acl"><em>White Oleander</em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PaintItBlack_ad_card_1.vue?7282242d